const currenciesResource = `/api/v1/currencies`;
import BaseRepository from "@/baseRepository/BaseRepository";

export default {
    getCurrencies(baseURL = {}, params = {}, headers = {}) {
      return BaseRepository.get(`${currenciesResource}`, {
        baseURL,
        params,
        headers,
      });
    },
}